import { render, staticRenderFns } from "./export-talk.vue?vue&type=template&id=06d77ce8&scoped=true&"
import script from "./export-talk.vue?vue&type=script&lang=js&"
export * from "./export-talk.vue?vue&type=script&lang=js&"
import style0 from "./export-talk.vue?vue&type=style&index=0&id=06d77ce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d77ce8",
  null
  
)

export default component.exports